<div class="headerContainer" fxLayout="row" fxLayoutAlign="center center">
  <div><img src='/assets/images/headshot.jpeg' class='headshot'/></div>
  <div fxLayout="column">
    <div class="name">Brian Hadley</div>  
    <div class="name">Software Engineer</div>  
  </div>
  
</div>
